import BaseDataManager from './base';
import { ServerSettings } from '@copilot/data/responses/interface';

class FeServerSettingsManager extends BaseDataManager {
    constructor() {
        super();
    }

    /**
     * Get all server settings from the backend
     * This is the preferred method to fetch server settings
     */
    public getServerSettings = async () => {
        const serverSettings = await this.RequestManager.get<ServerSettings>(
            this.BACKEND_ROUTES.SETTINGS.SERVER
        ).then((response) => response.data);
        return serverSettings;
    };
}

const instance = new FeServerSettingsManager();
export default instance;
